import {
    createContext,
    useContext,
    createSignal,
} from 'solid-js'

const PartnerContext = createContext()

export function PartnerProvider (props) {
    const [
        partnerConfig,
        setPartnerConfig,
    ] = createSignal(null)

    const api = {
        clearPartnerConfig: () => setPartnerConfig(null),
        isPartnerScoped: () => partnerConfig() !== null,
        partnerConfig,
        partnerSlug: () => partnerConfig()?.slug ?? null,
        setPartnerConfig,
    }

    return <PartnerContext.Provider value={api}>{props.children}</PartnerContext.Provider>
}

export function usePartner () {
    const context = useContext(PartnerContext)
    if (!context) {
        throw new Error('usePartner must be used within a PartnerProvider')
    }
    return context
}
